import styled from "../../../client-utils/styled/index.js";
import shouldForwardPropUtil from "../../../client-utils/styled/shouldForwardProp.util.js";
import { SINGLE, ZERO, DOUBLE, SEXDECUPLE, VIGINTUPLE, CHILIUPLE } from "../../../constants/numbers.consts.js";
import { CLIP_PATH_PADDING, TOOLTIP_PAPER_WIDTH } from "./constants.js";
import Paper from "../../../components/atoms/Paper/index.js";
import Box from "../../../components/atoms/Box/index.js";
import Button from "../../../components/atoms/Button/index.js";
const coreComponentName = "SdbFeatureDiscovery";
export const FeatureDiscoveryPaper = styled(Paper, {
    name: coreComponentName,
    slot: "Root",
    shouldForwardProp: shouldForwardPropUtil("tooltipPosition", "offset", "isVisible", "hasRendered"),
})(({ theme, tooltipPosition, offset, isVisible, hasRendered }) => ({
    backgroundColor: theme.palette.primary.main,
    position: "absolute",
    top: offset?.y ? tooltipPosition.top - offset.y : tooltipPosition.top,
    left: offset?.x ? tooltipPosition.left - offset.x : tooltipPosition.left,
    zIndex: 9999999,
    padding: SEXDECUPLE,
    color: theme.palette.common.white,
    width: TOOLTIP_PAPER_WIDTH,
    opacity: isVisible ? SINGLE : ZERO,
    transform: isVisible ? "scale(1)" : "scale(0.9)",
    transition: theme.transitions.create(hasRendered ? ["all"] : ["opacity", "transform"], {
        duration: hasRendered ? theme.transitions.duration.short : theme.transitions.duration.standard,
        easing: theme.transitions.easing.easeInOut,
    }),
    willChange: "opacity, transform",
}));
export const HighlightedAreaBox = styled(Box, {
    name: coreComponentName,
    slot: "HighlightedArea",
    shouldForwardProp: shouldForwardPropUtil("elementPosition"),
})(({ theme, elementPosition }) => ({
    position: "absolute",
    top: elementPosition.top - CLIP_PATH_PADDING,
    left: elementPosition.left - CLIP_PATH_PADDING,
    width: elementPosition.width + DOUBLE * CLIP_PATH_PADDING === VIGINTUPLE
        ? ZERO
        : elementPosition.width + DOUBLE * CLIP_PATH_PADDING,
    height: elementPosition.height + DOUBLE * CLIP_PATH_PADDING === VIGINTUPLE
        ? ZERO
        : elementPosition.height + DOUBLE * CLIP_PATH_PADDING,
    borderRadius: theme.spacing(DOUBLE),
    background: "transparent",
    boxShadow: `0 0 0 9999px rgba(${theme.vars.palette.secondary.darkChannel} / 0.2)`, // Creates a cutout effect
    pointerEvents: "none",
    zIndex: 9999999,
}));
export const OverlayBox = styled(Box, {
    name: coreComponentName,
    slot: "Overlay",
})(() => ({
    position: "absolute",
    top: ZERO,
    left: ZERO,
    background: "transparent",
    pointerEvents: "auto",
    zIndex: 9999998,
    width: "100dvw",
    height: "100dvh",
}));
export const FooterBox = styled(Box, {
    name: coreComponentName,
    slot: "Footer",
})(() => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: DOUBLE,
    mt: DOUBLE,
}));
export const FooterContentBox = styled(Box, {
    name: coreComponentName,
    slot: "FooterContent",
})(() => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: DOUBLE,
    width: "100%",
}));
export const FooterNavigationBox = styled(Box, {
    name: coreComponentName,
    slot: "FooterNavigation",
})(() => ({
    display: "flex",
    gap: DOUBLE,
}));
export const OverlayWithCutoutBox = styled(Box, {
    name: coreComponentName,
    slot: "OverlayWithCutout",
})(() => ({
    position: "fixed",
    inset: ZERO,
    pointerEvents: "none",
    zIndex: CHILIUPLE,
}));
export const CustomPreviousButton = styled(Button, {
    name: coreComponentName,
    slot: "CustomPreviousButton",
})(({ theme }) => ({
    color: theme.palette.common.white,
}));
export const CustomNextButton = styled(Button, {
    name: coreComponentName,
    slot: "CustomNextButton",
})(({ theme }) => ({
    color: theme.palette.common.black,
    backgroundColor: theme.palette.common.white,
    "&:hover": {
        backgroundColor: theme.palette.grey[100],
    },
}));
